import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class OrderGroupItemDTO  {
    _originalTypeClassName = "ekylikeio.BO.OrderGroupItemDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
OrderGroupItemDTO.translate = translateService;
}
this.Quantity = 1;
this.TotalPrice = null;
this.OriginalId = null;
this.Notes = null;
this.Status = null;
this.OrderGroupItemDTOKey = null;
this._key = this.OrderGroupItemDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Quantity:any;
TotalPrice:any;
OriginalId:any;
Notes:any;
Status:any;
MenuItem:any;
SchoolBreak:any;
private _OrderGroupItemDTOKey:any;
get OrderGroupItemDTOKey(): any {
    return this._OrderGroupItemDTOKey;
  }
set OrderGroupItemDTOKey(value: any) {
    this._OrderGroupItemDTOKey = value;
    this._key = value;
  }
static setMenuItem = ($this, value) => {
var oldValue = $this.MenuItem;
$this.MenuItem = value;
if (value != null) {
}
}
static setSchoolBreak = ($this, value) => {
var oldValue = $this.SchoolBreak;
$this.SchoolBreak = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.OrderGroupItemDTOKey == null || $this.OrderGroupItemDTOKey == 0;
            }


}